import store from './store/index.js'

import routes from './router.js'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const router = new VueRouter({
  // 默认
  // mode: 'history',

  // 打包时用
  mode: 'hash',
  routes
});

import Vue from 'vue'
import app from './App.vue'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import jq from './store/jquery-3.3.1.min.js'
Vue.prototype.$jq = jq

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)

// import VueI18n from 'vue-i18n'
// Vue.use(VueI18n)
// const i18n = new VueI18n({
//   locale: 'en-US', // 语言标识
//   //this.$i18n.locale='zh-CN'// 通过切换locale的值来实现语言切换
//   messages: {
//     'zh-CN': require('./lang/zh.js'), // 中文语言包
//     'en-US': require('./lang/en.js') // 英文语言包
//   }
// })

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

import zh from './lang/zh.js'
import en from './lang/en.js'
// Vue.use(ElementUI)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en-US', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': {
      ...zh,
      ...zhLocale
    }, // 中文语言包
    'en-US': {
      ...en,
      ...enLocale
    } // 英文语言包
  }
})
// console.log({
//   ...zh,
//   ...zhLocale
// }, {
//   ...en,
//   ...enLocale
// }, zh)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// $t('App.mian_sidebar.mailbox')
//  if (val === '0') {
//    this.$i18n.locale = 'zh-CN'
//  } else {
//    this.$i18n.locale = 'en-US'
//  }
// this_.version === '1'

// 打印功能
// cnpm install vue-print-nb --save
// import Print from 'vue-print-nb'
// Vue.use(Print);  //注册
/**
 * 
 * 
<div id="printTest" >
　　<p>明月照于山间</p>
　　<p>清风来于江上 </p>
</div>
<button v-print="'#printTest'">打印</button> 
 * 
 * 
 * 
 */

var vm = new Vue({
  store,
  router,
  el: '#app',
  i18n,
  components: {
    app
  }
})



// WEBPACK FOOTER //
// ./src/main.js